import { render, staticRenderFns } from "./cardReceiptDetail.vue?vue&type=template&id=3aa5447c&scoped=true"
import script from "./cardReceiptDetail.vue?vue&type=script&lang=js"
export * from "./cardReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./cardReceiptDetail.vue?vue&type=style&index=0&id=3aa5447c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5447c",
  null
  
)

export default component.exports